module.exports = __webpack_public_path__ + "static/media/contact-gif.ac7a8d84.gif";